import Footer from "./Footer"
import Header from "./Header"
import PresentationSection from "./PresentationSection"
import PillarsSection from "./PillarsSection"

export default function Home() {
  return (
    <>
      <Header />
      <PillarsSection />
      <PresentationSection />
      <Footer />
    </>
  )
}